import { format, subDays } from 'date-fns';
import { GlobalSettingsModel } from 'models/Shared/GlobalSettingsModel';
import { DATE_FORMAT_API } from '../../../../../../../../@constants/date';
import { FlashManagerReportFormModel } from '../../models';

export const getDefaultValues = (
  globalSettings: GlobalSettingsModel
): FlashManagerReportFormModel => ({
  date: format(subDays(new Date(globalSettings?.frontend_date), 1), DATE_FORMAT_API),
  show_net: false,
  file_type: 'pdf',
});
